import { render } from "./BlackHeader.vue?vue&type=template&id=67a4e64a&scoped=true"
import script from "./BlackHeader.vue?vue&type=script&lang=js"
export * from "./BlackHeader.vue?vue&type=script&lang=js"

import "./BlackHeader.vue?vue&type=style&index=0&id=67a4e64a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a4e64a"]])

export default __exports__